var _rect, _rect2, _circle, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessfulPayment(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 688,
    height: 404,
    viewBox: "0 0 688 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 140.5,
    width: 687,
    height: 263,
    rx: 31.5,
    stroke: "#71B48D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 608,
    height: 264,
    rx: 32,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 100,
    r: 100,
    fill: "#71B48D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.142 77.349C376.882 78.9922 376.96 81.7348 375.317 83.4747L341.545 119.233C338.192 122.783 332.569 122.864 329.116 119.411L312.769 103.063C311.077 101.371 311.077 98.6275 312.769 96.9352C314.461 95.243 317.205 95.243 318.897 96.9352L335.245 113.282L369.016 77.524C370.66 75.7841 373.402 75.7057 375.142 77.349Z",
    fill: "#F6F4F2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulPayment);
export default __webpack_public_path__ + "static/media/successful-payment.1f18d32ba186dc543116083a12e3a177.svg";
export { ForwardRef as ReactComponent };